export default __webpack_public_path__ + "static/media/InsideStomach_00.9b397806.png";